var map = {
	"./de.png": 1000,
	"./en.png": 1001,
	"./es.png": 1002,
	"./fr.png": 1003,
	"./ja.png": 1004,
	"./mk.png": 1005,
	"./pt.png": 1006,
	"./tr.png": 1007,
	"./zh.png": 1008
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 999;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags ^\.\/.*\.png$
// module id = 999
// module chunks = 0